import { commonTypes } from './common';
import { decideStepToLoad } from '../stepper/stepperDecisor';
import * as Conditions from '../conditions/conditions';
import { personalDataStep } from '../flowDefinition/commonSteps';

import { executeEveryReducerParts, sortAlphabeticallyInitialState } from './utils/customCombineReducers';

import UINeedsPersonalDataReducer, {
  actions as uiNeedsPersonalDataActions,
  initialState as uiNeedsPersonalDataInitialState,
} from './uiNeeds/uiNeedsPersonalData';
import UINeedsOBDReducer, {
  actions as uiNeedsOBDActions,
  initialState as uiNeedsOBDInitialState,
} from './uiNeeds/uiNeedsObd';
import UINeedsStepsReducer, {
  actions as uiNeedsStepsActions,
  initialState as uiNeedsStepsInitialState,
} from './uiNeeds/uiNeedsSteps';
import UINeedsInstallationReducer, {
  actions as uiNeedsInstallationActions,
  initialState as uiNeedsInstallationInitialState,
} from './uiNeeds/uiNeedsInstallation';
import UINeedsMyProductsReducer, {
  actions as uiNeedsMyProductsActions,
  initialState as uiNeedsMyProductsInitialState,
} from './uiNeeds/uiNeedsMyProducts';
import UINeedsParentProductsReducer, {
  actions as uiNeedsParentProductsActions,
  initialState as uiNeedsParentProductsInitialState,
} from './uiNeeds/uiNeedsParentProducts';
import UINeedsClientActionReducer, {
  actions as uiNeedsClientActionActions,
  initialState as uiNeedsClientActionInitialState,
} from './uiNeeds/uiNeedsClientAction';
import UINeedsPpipReducer, {
  actions as uiNeedsPpipActions,
  initialState as uiNeedsPpipInitialState,
} from './uiNeeds/uiNeedsPpip';
import UINeedsUpdateCQReducer, {
  actions as uiNeedsUpdateCQActions,
  initialState as uiNeedsUpdateCQInitialState,
} from './uiNeeds/uiNeedsUpdateCQ';
import UINeedsAccountReducer, {
  actions as uiNeedsAccountActions,
  initialState as uiNeedsAccountInitialState,
} from './uiNeeds/uiNeedsAccount';
import UINeedsRiskReducer, {
  actions as uiNeedsRiskActions,
  initialState as uiNeedsRiskInitialState,
  types as uiNeedsRiskTypes,
} from './uiNeeds/uiNeedsRisk';
import UINeedsOfferReducer, {
  actions as uiNeedsOfferActions,
  initialState as uiNeedsOfferInitialState,
} from './uiNeeds/uiNeedsOffer';
import UINeedsMobileInsuranceReducer, {
  actions as uiNeedsMobileInsuranceActions,
  initialState as uiNeedsMobileInsuranceInitialState,
} from './uiNeeds/uiNeedsMobileInsurance';
import UINeedsDeviceReducer, {
  actions as uiNeedsDeviceActions,
  initialState as uiNeedsDeviceInitialState,
} from './uiNeeds/uiNeedsDevice';
import UINeedsSummaryReducer, {
  actions as uiNeedsSummaryActions,
  initialState as uiNeedsSummaryInitialState,
} from './uiNeeds/uiNeedsSummary';
import UINeedsConfirmationReducer, {
  actions as uiNeedsConfirmationActions,
  initialState as uiNeedsConfirmationInitialState,
} from './uiNeeds/uiNeedsConfirmation';
import UINeedsVTLReducer, {
  actions as uiNeedsVTLActions,
  initialState as uiNeedsVTLInitialState,
} from './uiNeeds/uiNeedsVTL';
import UINeedsTerminalDataReducer, {
  actions as uiNeedsTerminalDataActions,
  initialState as uiNeedsTerminalDataInitialState,
} from './uiNeeds/uiNeedsTerminalData';
import UINeedsPaymentReducer, {
  actions as uiNeedsPaymentActions,
  initialState as uiNeedsPaymentInitialState,
} from './uiNeeds/uiNeedsPayment';
import UINeedsCommitmentReducer, {
  actions as uiNeedsCommitmentActions,
  initialState as uiNeedsCommitmentInitialState,
} from './uiNeeds/uiNeedsCommitment';
import UINeedsRegisterReducer, {
  actions as uiNeedsRegisterActions,
  initialState as uiNeedsRegisterInitialState,
} from './uiNeeds/uiNeedsRegister';

export const types = {
  SET_CONTEXT_DATA: 'SET_CONTEXT_DATA',
  ...uiNeedsRiskTypes,
};

export const messyInitialState = {
  actualStepIndex: 0,
  ...uiNeedsPersonalDataInitialState,
  ...uiNeedsOBDInitialState,
  ...uiNeedsStepsInitialState,
  ...uiNeedsInstallationInitialState,
  ...uiNeedsMyProductsInitialState,
  ...uiNeedsParentProductsInitialState,
  ...uiNeedsClientActionInitialState,
  ...uiNeedsPpipInitialState,
  ...uiNeedsUpdateCQInitialState,
  ...uiNeedsAccountInitialState,
  ...uiNeedsRiskInitialState,
  ...uiNeedsOfferInitialState,
  ...uiNeedsMobileInsuranceInitialState,
  ...uiNeedsDeviceInitialState,
  ...uiNeedsSummaryInitialState,
  ...uiNeedsConfirmationInitialState,
  ...uiNeedsVTLInitialState,
  ...uiNeedsTerminalDataInitialState,
  ...uiNeedsPaymentInitialState,
  ...uiNeedsCommitmentInitialState,
  ...uiNeedsRegisterInitialState,
  userType: '',
};

const initialState = sortAlphabeticallyInitialState(messyInitialState);

const reducerParts = [
  UINeedsPersonalDataReducer,
  UINeedsOBDReducer,
  UINeedsStepsReducer,
  UINeedsInstallationReducer,
  UINeedsMyProductsReducer,
  UINeedsParentProductsReducer,
  UINeedsClientActionReducer,
  UINeedsPpipReducer,
  UINeedsUpdateCQReducer,
  UINeedsAccountReducer,
  UINeedsRiskReducer,
  UINeedsOfferReducer,
  UINeedsMobileInsuranceReducer,
  UINeedsDeviceReducer,
  UINeedsSummaryReducer,
  UINeedsConfirmationReducer,
  UINeedsVTLReducer,
  UINeedsTerminalDataReducer,
  UINeedsPaymentReducer,
  UINeedsCommitmentReducer,
  UINeedsRegisterReducer,
];

// eslint-disable-next-line @typescript-eslint/default-param-last
const UINeedsReducer = (state = JSON.parse(JSON.stringify(initialState)), action) => {
  let newState = {
    ...state,
  };

  const reducerPartsExecutionResult = executeEveryReducerParts(reducerParts, state, action);

  if (reducerPartsExecutionResult
    && reducerPartsExecutionResult.state
  ) {
    if (reducerPartsExecutionResult.stepsMustBeEvaluated) {
      newState = reducerPartsExecutionResult.state;
    } else {
      return reducerPartsExecutionResult.state;
    }
  } else {
    switch (action.type) {
      case commonTypes.RESET_FLOW: {
        return {
          ...JSON.parse(JSON.stringify(initialState)),
          flowInfo: state.flowInfo,
          actualStep: personalDataStep,
          clientInfo: state.clientInfo,
        };
      }
      case commonTypes.RESET_ASCERTAIN: {
        const newSteps = [...state.flowInfo.flowJson.steps];
        if (state.flowInfo.flowJson.secondaryRoundsSteps) {
          const indexOfActualStep = state.flowInfo.flowJson.steps.indexOf(state.actualStep);
          const currentDate = new Date();
          const timestamp = currentDate.getTime();

          const newSecondaryRoundsSteps = JSON.parse(JSON.stringify(state.flowInfo.flowJson.secondaryRoundsSteps));

          newSecondaryRoundsSteps.forEach((step) => {
          // eslint-disable-next-line no-param-reassign
            step.searchId = `${step.searchId}-${timestamp}`;
          });

          newSteps.splice(indexOfActualStep + 1, 0, ...newSecondaryRoundsSteps);
        }

        newState = {
          ...state,
          mainOptionsObj: initialState.mainOptionsObj,
          secondaryOptionsObj: initialState.secondaryOptionsObj,
          addToCartNeeds: initialState.addToCartNeeds,
          ppipAvailable: initialState.ppipAvailable,
          flowInfo: {
            ...state.flowInfo,
            flowJson: {
              ...state.flowInfo.flowJson,
              steps: newSteps,
            },
          },
          blockedUIStep: initialState.blockedUIStep,
          confirmedSteps: initialState.confirmedSteps,
        };

        break;
      }
      case types.SET_CONTEXT_DATA: {
        const { userType } = action.payload;

        newState.userType = userType;
        break;
      }
      default: newState = null;
    }
  }

  if (!newState) {
    return { ...state };
  }

  if (newState.blockedUIStep) {
    return {
      ...newState,
    };
  }

  const {
    newStep,
    actualStepIndex,
  } = decideStepToLoad(newState, Conditions, newState.flowInfo.flowJson);

  let blockedUIStep = false;
  if (state.actualStep && newStep && state.actualStep.id !== newStep.id) {
    blockedUIStep = true;
  }

  return {
    ...newState,
    actualStep: newStep,
    actualStepIndex,
    blockedUIStep,
  };
};

export const actions = {
  ...uiNeedsOBDActions,
  ...uiNeedsPersonalDataActions,
  ...uiNeedsStepsActions,
  ...uiNeedsInstallationActions,
  ...uiNeedsMyProductsActions,
  ...uiNeedsParentProductsActions,
  ...uiNeedsClientActionActions,
  ...uiNeedsPpipActions,
  ...uiNeedsUpdateCQActions,
  ...uiNeedsAccountActions,
  ...uiNeedsRiskActions,
  ...uiNeedsOfferActions,
  ...uiNeedsMobileInsuranceActions,
  ...uiNeedsDeviceActions,
  ...uiNeedsSummaryActions,
  ...uiNeedsConfirmationActions,
  ...uiNeedsVTLActions,
  ...uiNeedsTerminalDataActions,
  ...uiNeedsPaymentActions,
  ...uiNeedsCommitmentActions,
  ...uiNeedsRegisterActions,
};

export default UINeedsReducer;
